export default {
  FETCH_QUESTION_ANSWERS(state, data) {
    state.questionAnswers = data
  },

  SET_QUESTION_ANSWER_LOADING(state, status) {
    state.questionAnswerLoading = status
  },

  SET_CURRENT_ID(state, id) {
    state.currentId = id
  },

  SET_CATEGORY(state, array) {
    state.category = array
  },
  SET_ISOPENED(state, id) {
    state.isOpened[id] = !state.isOpened[id]
  }
}
